import {
  BooleanInput,
  SimpleForm,
  required,
  SelectInput,
  email,
} from "react-admin";
import LogsField from "./fields/LogsField";
import React from "react";
import {
  DebouncedTextInput,
  ReferenceCheckboxGroupInput,
  Toolbar,
  useSaveMutation,
} from "ra-friendsofbabba";
import UserLogsField from "./fields/UserLogsField";

export const STATUSES = [
  {
    id: "pending",
    name: "resources.users.status.pending",
  },
  {
    id: "active",
    name: "resources.users.status.active",
  },
  {
    id: "banned",
    name: "resources.users.status.banned",
  },
];

const Form = ({ create = false, permissions, ...props }) => {
  const save = useSaveMutation({ ...props });
  return (
    <SimpleForm
      {...props}
      save={save}
      initialValues={{
        accepted_disclaimer: true,
        accepted_regulation: true,
      }}
      toolbar={<Toolbar />}
    >
      <SelectInput source="status" validate={required()} choices={STATUSES} />
      <DebouncedTextInput
        source="profile.name"
        validate={required()}
        maxLength={50}
      />
      <DebouncedTextInput
        source="profile.surname"
        validate={required()}
        maxLength={50}
      />
      <DebouncedTextInput
        source="username"
        validate={required()}
        maxLength={100}
      />
      <DebouncedTextInput
        source="profile.phone"
        validate={required()}
        maxLength={30}
      />
      <DebouncedTextInput
        source="profile.fiscal_code"
        maxLength={16}
        validate={[required()]}
      />
      <DebouncedTextInput source="password" type="password" />
      <DebouncedTextInput source="profile.spid_code" disabled />
      <BooleanInput
        source="allow_local_login"
        helperText="resources.users.fields.allow_local_login.help"
      />
      <DebouncedTextInput
        source="email"
        validate={[required(), email()]}
        maxLength={255}
      />
      <ReferenceCheckboxGroupInput
        reference="roles"
        source="roles"
        validate={required()}
        fullWidth
      />
      <LogsField fullWidth />
      <UserLogsField fullWidth />
    </SimpleForm>
  );
};
export default Form;
